let init = false;
let firstScrollToTop = false;

class IframeWidget {
    static initialize() {

        let parentHeight = undefined;
        let top = undefined as any | undefined;
        let lastSent = 0;
        window.addEventListener('wheel', (e) => {
            const now = Date.now();
            if (now - lastSent < 16) return; // ~60fps throttle
            lastSent = now;

            window.parent.postMessage({
                type: 'IFRAME_WHEEL',
                deltaY: e.deltaY,
                ts: now
            }, '*');
        }, {passive: true});

        function onElementHeightChange(elm: any, callback: any) {
            var lastHeight = elm.clientHeight, newHeight;
            (function run() {
                newHeight = elm.clientHeight;
                if (lastHeight != newHeight) {
                    callback(newHeight)
                }
                lastHeight = newHeight

                if (elm.onElementHeightChangeTimer)
                    clearTimeout(elm.onElementHeightChangeTimer)

                elm.onElementHeightChangeTimer = setTimeout(run, 200)
            })()
        }

        function fixFixedElements(top: any, bottom: any, parentHeight: any) {
            if (top < 0) {
                top = 0;
            }

            let fixedBottomBottom = bottom - parentHeight;
            if (fixedBottomBottom < 15) {
                fixedBottomBottom = 15;
            }
            let fixedBottom = document.getElementsByClassName("fixed-bottom");
            Array.from(fixedBottom).forEach((el) => {
                (el as any).style.transform = `translate3d(0, ${-fixedBottomBottom}px, 0)`;
            });

            const stickyFixed = document.getElementsByClassName("sticky-fixed");
            const stickyTopElements = document.getElementsByClassName("sticky-top");
            const promoTopBanner = document.getElementsByClassName(
                "promo-top-banner"
            )[0] as HTMLElement | undefined;
            var promoTopBannerHeight = promoTopBanner ? promoTopBanner.offsetHeight : 0;

            Array.from(stickyFixed).forEach((el) => {
                (el as HTMLElement).style.transform = `translate3d(0, ${top}px, 0)`;
            });

            var topStickyTop = top - promoTopBannerHeight;
            if (topStickyTop < 0) topStickyTop = 0;
            Array.from(stickyTopElements).forEach((el) => {
                (el as HTMLElement).style.transform = `translate3d(0, ${topStickyTop}px, 0)`;
            });

            let modals = document.getElementsByClassName("modal");
            Array.from(modals).forEach((el) => {
                (el as any).style.top = top + "px";
                let modalDialogs = el.getElementsByClassName("modal-dialog");
                Array.from(modalDialogs).forEach((el1) => {
                    (el1 as any).style.height = parentHeight + "px";
                    const modalContentElement = el1.querySelector(".modal-content");
                    if (modalContentElement) {
                        (modalContentElement as HTMLDivElement).style.maxHeight = `calc(${window.innerHeight}px - ${top}px)`;
                    }
                });
            });

            if (parentHeight > 0) {
                let fullHeight = document.getElementsByClassName("fixed-height-100");
                const iframeRect = window.frameElement?.getBoundingClientRect()

                Array.from(fullHeight).forEach((el) => {
                    const iframeRectTop = iframeRect?.top ?? 0;
                    (el as any).style.height = parentHeight
                        - (parentHeight > bottom ? parentHeight - bottom : 0)
                        - (iframeRectTop > 0 ? iframeRectTop : 0)
                        + "px";
                });
            }
        }

        if (window.top != window.self) {
            if (!init) {
                init = true;
                // window.document.body.classList.add("widget");
                onElementHeightChange(document.body, function (h: any) {
                    let message = {type: 'HEIGHT_CHANGED', height: h};
                    window.parent.postMessage(message, "*");
                    // console.log('Body height changed:', h)
                });

                // window.addEventListener('scroll', function(e) {
                //     console.log(e);
                // });
            }
        }
        window.addEventListener("message", function (data) {
            if (data.data === undefined) {
                return;
            }
            switch (data.data.type) {
                case "ENABLE_FULLSCREEN_OFFSET":
                    var widgetElement = document.getElementsByClassName("widget");
                    let iframeOffsetTop = data.data.iframeOffsetTop;

                    Array.from(widgetElement).forEach((el) => {
                        (el as any).style.top = iframeOffsetTop + "px";
                    });
                    let stickyFixedTop = iframeOffsetTop < 0 ? 0 : iframeOffsetTop;
                    var stickyFixed = document.getElementsByClassName("sticky-fixed");
                    const stickyTopElements = document.getElementsByClassName("sticky-top") as HTMLCollectionOf<HTMLElement>;

                    Array.from(stickyFixed).forEach((el) => {
                        // el.style.top =  iframeOffsetTop + "px";
                        (el as any).style.top = stickyFixedTop + "px";
                    });

                    Array.from(stickyTopElements).forEach((el) => {
                        el.style.top = 0 + "px";
                    });
                    break;
                case "DISABLE_FULLSCREEN_OFFSET":
                    window.dispatchEvent(new Event('scroll', {detail: top} as any));
                    window.dispatchEvent(new CustomEvent('scroll-iframe', {
                        detail: {
                            top,
                            parentOffset: data.data?.iframeParentOffsetTop ?? 0
                        }
                    }));
                    top = data.data.iframeOffsetTop * -1;
                    var bottom = data.data.iframeOffsetBottom;
                    parentHeight = data.data.iframeParentHeight;
                    fixFixedElements(top, bottom, parentHeight);
                    var widgetElement = document.getElementsByClassName("widget");
                    Array.from(widgetElement).forEach((el) => {
                        (el as any).style.top = "";
                    });
                    break;
                case "PARENT_SCROLL":
                    window.dispatchEvent(new Event('scroll', {detail: top} as any));
                    window.dispatchEvent(new CustomEvent('scroll-iframe', {
                        detail: {
                            top,
                            parentOffset: data.data?.iframeParentOffsetTop ?? 0
                        }
                    }));
                    top = data.data.iframeOffsetTop * -1;
                    var bottom = data.data.iframeOffsetBottom;
                    parentHeight = data.data.iframeParentHeight;
                    fixFixedElements(top, bottom, parentHeight);
                    break;
            }
        }, false);
    }

    static isInit() {
        return init;
    }

    static scrollToTop() {
        if (init) {
            let message = {type: 'HEIGHT_CHANGED', height: document.body.clientHeight, scroll_to_top: firstScrollToTop};
            window.parent.postMessage(message, "*");
            firstScrollToTop = true;
        }
    }

    static scrollTo(value: any) {
        if (init) {
            let message = {type: 'SCROLL_PARENT_TO_IFRAME_OFFSET', offset: value};
            window.parent.postMessage(message, "*");
        }
    }

    static openModal() {
        if (init) {
            let message = {type: 'SIZE_STRETCH'};
            window.parent.postMessage(message, "*");
        }
    }

    static closeModal() {
        if (init) {
            let message = {type: 'SIZE_DEFAULT'};
            window.parent.postMessage(message, "*");
        }
    }

    static onHide(onHide?: any) {
        if (onHide) onHide();
        IframeWidget.closeModal();
    }

    static onShow(onShow?: any) {
        if (onShow) onShow();
        IframeWidget.openModal();
    }
}

export default IframeWidget;
